import React, { ReactElement } from 'react'
import { FieldError, Control, RegisterOptions } from 'react-hook-form'
import FormHelperText from '@material-ui/core/FormHelperText'
import { Typography, Grid } from '@material-ui/core'
import { SizeOptions } from 'TypeDefs/FormSongs'
import TitleWithTooltip from 'Components/SongComponents/TitleWithTooltipSong/TitleWithTooltipSong'
import useStyles from './FormSongs/SelectSong/SelectSong.styles'

type FormElementWithErrorProps = {
  child: ReactElement
  register?: () => void
  control?: Control
  error: FieldError
  rules?: RegisterOptions
  rowsMax?: number
  required?: boolean
  header?: string
  subheader?: string
  size: SizeOptions
  maxLength: number
  titleWithTooltip?: string
  tooltipIndex?: number
  tooltipText?: string
  helperMessage?: string
}

export const FormElementWithError = ({
  child,
  register,
  control,
  error,
  rules,
  required,
  rowsMax,
  header,
  subheader,
  size,
  maxLength,
  titleWithTooltip,
  tooltipIndex,
  tooltipText,
  helperMessage,
}: FormElementWithErrorProps) => {
  const classes = useStyles()
  return (
    <Grid item className={classes.input} xs={size}>
      {header && (
        <Typography variant='h5' className={classes.header}>
          {header}
        </Typography>
      )}
      {subheader && (
        <Typography variant='body1' className={classes.subheader}>
          {subheader}
        </Typography>
      )}
      {titleWithTooltip && (
        <TitleWithTooltip
          title={titleWithTooltip}
          tooltipIndex={tooltipIndex}
          tooltipText={tooltipText}
        />
      )}

      {React.createElement(child.type, {
        ...{
          ...child.props,
          register,
          control,
          key: child.props.name,
          rowsMax,
          error,
          rules,
          required,
          size,
          maxLength,
        },
      })}
      {helperMessage && (
        <Typography variant='body2' className={classes.helper}>
          {helperMessage}
        </Typography>
      )}
      {error && (
        <FormHelperText
          className={classes.errorMessage}
          data-testid={`${child.props.name}-error`}
          error={!!error}
        >
          {error.message}
        </FormHelperText>
      )}
    </Grid>
  )
}
